import { Outlet, useLocation } from 'react-router-dom';

/**
 * Wraps <Outlet /> with a 120ms fade + 4px slide-in-from-bottom-1 transition,
 * keyed on pathname so React remounts the wrapper between routes. Pure CSS via
 * tailwindcss-animate; respects prefers-reduced-motion through the
 * motion-reduce: variants.
 *
 * Used in both the admin shell (`AppLayout`) and the partner portal shell
 * (`PortalLayout`).
 */
export function RouteTransition() {
  const location = useLocation();
  return (
    <div
      key={location.pathname}
      data-testid="route-transition"
      className="motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-1 motion-safe:duration-150"
    >
      <Outlet />
    </div>
  );
}
